'use client';

import type { CerFeatures } from '@slims/shared/data';
import { useContextOrg } from './use-context-org';
import { useScopeTree } from './use-scope-tree';

const UNAVAILABLE: CerFeatures = { aiSuggestions: 'disabled', reports: false, anomalies: false };

/** An explicit scope wins; never borrow capabilities from another selected CER. */
export function useCerFeatures(orgId?: string | null) {
	const context = useContextOrg();
	const { leaves, loading } = useScopeTree();
	const leaf = orgId === undefined ? context : leaves.find((row) => row.orgId === orgId);
	return { features: leaf?.features ?? UNAVAILABLE, loading };
}
